import { createFileRoute } from '@tanstack/react-router'

import { EditTicketPage } from '@/components/Tickets/EditTicketPage'

/** Wiring only. */
export const Route = createFileRoute('/_app/tickets/$ticketId/edit/')({
  component: EditTicketRoute,
})

function EditTicketRoute() {
  const { ticketId } = Route.useParams()

  return <EditTicketPage ticketId={ticketId} />
}
